import { inject, Service } from "@angular/core";

import { environment } from "../../../core/environments/environment";
import { AdaaHelper } from "../../../core/utils";
import { Constants } from "../../../shared/constants/constants";
import { Language } from "../../../shared/constants/enums";
import { UsersApiService } from "../../../shared/services/users-api-service";

export type Adaa4Dashboard = "govDashboard" | "strategyDashboard" | "internationalDashboard" | "agenticDashboard";

@Service()
export class Adaa4RedirectService {
  private readonly _usersApiService = inject(UsersApiService);

  public dashboardUrl(dashboard: Adaa4Dashboard, language: Language): string {
    const suffix = language === Language.Arabic ? "AE" : "EN";
    return environment.adaa4Dashboards[`${dashboard}${suffix}`];
  }

  public open(url: string): void {
    const sessionId = AdaaHelper.getLocalStorage(Constants.localStorageKeys.sessionId, { type: "string" }) as string;
    const userEntityId = AdaaHelper.getLocalStorage(Constants.localStorageKeys.user, {
      type: "prop",
      property: "entityId",
    }) as string;

    this._usersApiService.getHashedSessionId(sessionId).subscribe({
      next: (res) => {
        if (res.inError) return;

        const encodedSessionId = encodeURIComponent(res.responseData);
        // replace() instead of href so the current page is dropped from history and Back can't return to it
        window.location.replace(`${url}?entityId=${userEntityId}&sessionId=${encodedSessionId}`);
      },
    });
  }
}
